import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form, Input, TextArea, Search} from 'semantic-ui-react';
import {reverseShortDate} from '../../../../../../common/constants/datesFormat';
import {Actions} from '../../../../../../common/actions';
import {getSearchOptions} from '../../../../../utils';

const Divisor = ({text, bulletinId}) => {
  return (
    <p className="bulletin-divisor">
      {text}
      {bulletinId && <span>{bulletinId}</span>}
    </p>
  );
};

const initialState = {
  'modelLoading': false,
  'katashikiLoading': false,
  'openModel': false,
  'resultsModel': [],
  'openKatashiki': false,
  'resultsKatashiki': [],
};

class BulletinForm extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentDidUpdate(prevProps) {
    const {modelList, katashikiList, loading} = this.props;
    if (prevProps.loading && !loading) {
      if (prevProps.loading !== modelList.length) {
        this.setState({
          'resultsModel': getSearchOptions(modelList, 'model'),
          'openModel': false,
          'modelLoading': false,
        });
      }
      if (prevProps.katashikiList.length !== katashikiList.length) {
        this.setState({
          'resultsKatashiki': getSearchOptions(katashikiList, 'katashiki'),
          'openKatashiki': false,
          'katashikiLoading': false,
        });
      }
      this.setState({
        'modelLoading': false,
        'katashikiLoading': false,
      });
    }
  }

  parseVehicleSystems = (list = []) => {
    return list.map((element, idx) => ({
      'key': idx,
      'text': element.description,
      'value': element.bulletinId,
    }));
  };

  handleSearchChange = (e, {name, value}) => {
    const {onUpdateForm} = this.props;
    const finalValue = value.toUpperCase();
    onUpdateForm(e, {name, value});
    if (value.length > 1) {
      const loadingName = `${name}Loading`;
      this.setState({[loadingName]: true});
      this.props.fetchVehicleQuery({[name]: finalValue});
    }
  };

  render() {
    const {
      bulletinId,
      model,
      katashiki,
      subject,
      createdDate,
      onUpdateForm,
      id,
    } = this.props;
    const {resultsModel, resultsKatashiki, modelLoading, katashikiLoading} = this.state;
    const formatDate = createdDate.format(reverseShortDate);

    return (
      <Form>
        <Divisor text="Boletín Id" bulletinId={bulletinId} />
        <Form.Group widths="three">
          <Form.Field
            value={katashiki}
            control={Search}
            disabled={!!id}
            loading={katashikiLoading}
            results={resultsKatashiki}
            showNoResults={false}
            name="katashiki"
            onResultSelect={(e, {name, result}) =>
              onUpdateForm(e, {name, 'value': result.title})
            }
            onSearchChange={this.handleSearchChange}
            label="Katashiki"
            placeholder="Katashiki"
          />
          <Form.Field
            value={model}
            control={Search}
            onResultSelect={(e, {name, result}) =>
              onUpdateForm(e, {name, 'value': result.title})
            }
            loading={modelLoading}
            results={resultsModel}
            onSearchChange={this.handleSearchChange}
            disabled={!!id}
            showNoResults={false}
            label="Modelo"
            name="model"
            placeholder="Modelo"
          />
          <Form.Field
            value={formatDate}
            control={Input}
            readOnly
            label="Fecha publicación"
            placeholder="Fecha publicación"
          />
        </Form.Group>
        <Form.Group widths="one">
          <Form.Field
            value={subject}
            control={TextArea}
            disabled={!!id}
            onChange={onUpdateForm}
            name="subject"
            label="Asunto"
            placeholder="Asunto"
          />
        </Form.Group>
      </Form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'vehicleSystems': state.vehicleSystems.list,
    'modelList': state.vehicleQuery.modelList,
    'katashikiList': state.vehicleQuery.katashikiList,
    'loading': state.vehicleQuery.loading,
  };
};

const {
  fetchVehicleQuery,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  fetchVehicleQuery,
  navigateTo,
})(BulletinForm);
